import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api/client';
export default function PublishStep({ onChanged }) {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    async function refresh() {
        setError(null);
        try {
            setData(await api.wizardPublishState());
            onChanged();
        }
        catch (e) {
            setError(e?.message ?? 'Failed to load');
        }
    }
    useEffect(() => { refresh(); }, []);
    async function flip(target) {
        setBusy(true);
        setError(null);
        try {
            setData(await api.wizardPublish(target));
            onChanged();
        }
        catch (e) {
            setError(e?.message ?? 'Failed');
        }
        finally {
            setBusy(false);
        }
    }
    if (!data)
        return _jsx("div", { className: "muted", children: "Loading\u2026" });
    return (_jsxs("div", { className: "step-content", children: [_jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "Pre-flight checklist" }), _jsx("ul", { className: "checklist", children: data.checklist.map((c) => (_jsxs("li", { className: c.ok ? 'ok' : 'todo', children: [_jsx("span", { className: "check", children: c.ok ? '✓' : '!' }), _jsx("span", { className: "check-label", children: c.label }), c.detail && _jsx("span", { className: "muted small check-detail", children: c.detail })] }, c.key))) })] }), _jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "Environment" }), _jsxs("p", { children: ["Currently ", _jsxs("code", { children: ["SITE_ENV=", data.env.find((e) => e.key === 'SITE_ENV')?.value || 'local'] }), ". ", data.is_live ? 'The admin is openly reachable.' : 'The admin is gated to local-only by SITE_ENV=local.'] }), _jsx("div", { className: "step-foot", children: data.is_live
                            ? _jsx("button", { className: "ghost", onClick: () => flip('local'), disabled: busy, children: "Take offline (back to local)" })
                            : _jsx("button", { onClick: () => flip('production'), disabled: busy, children: "Go live (SITE_ENV=production)" }) })] }), data.is_live && (_jsxs("section", { className: "card-section publish-done", children: [_jsx("h2", { children: "\uD83C\uDF89 You're live" }), _jsx("p", { className: "muted small", children: "The site is reachable at the configured URL. The admin dashboard tracks ongoing health from here on \u2014 submissions, broken links, missing alt text, and so on." }), _jsx("div", { className: "step-foot", children: _jsx("button", { onClick: () => navigate('/'), children: "Go to dashboard \u2192" }) })] })), error && _jsx("div", { className: "err small pad-y", children: error })] }));
}
